import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Plus } from "lucide-react";
import { Reveal } from "./Reveal";

const faqs = [
  {
    q: "¿Cómo funciona el acceso privado?",
    a: "Cargás tu lista de invitados con sus teléfonos. Cuando alguien abre el enlace, ingresa su número: si está registrado, accede a su invitación con sus pases y su mesa. La validación solo comprueba que el número esté en la lista; no envía códigos de verificación y no impide que un invitado comparta su propio acceso.",
  },
  {
    q: "¿Mis invitados tienen que instalar una aplicación?",
    a: "No. La invitación se abre directamente en el navegador del teléfono o la computadora, desde el mismo enlace que compartís con todos.",
  },
  {
    q: "¿Puedo personalizar el diseño?",
    a: "Sí. El diseñador visual te permite elegir portada, secciones, galería de hasta cuatro imágenes, música con Spotify o un archivo MP3, video de YouTube, itinerario y enlaces personalizados, con vista previa móvil y de escritorio.",
  },
  {
    q: "¿Cómo funcionan las confirmaciones?",
    a: "Cada invitado confirma desde la propia invitación. Vos ves en tu panel quién confirmó, quién está pendiente y quién no podrá asistir, junto con los pases de cada grupo.",
  },
  {
    q: "¿Puedo enviar la invitación por WhatsApp?",
    a: "Sí. Preparamos un mensaje individual para cada invitado, con su nombre y sus pases, listo para copiar y enviar desde tu propio WhatsApp. No realizamos envíos masivos automatizados.",
  },
  {
    q: "¿Tengo que preparar un enlace para cada invitado?",
    a: "No. Un mismo enlace sirve para todos: en las modalidades privada y mixta, cada invitado se identifica con su teléfono al ingresar.",
  },
];

export const Faq = () => {
  const [open, setOpen] = useState(0);

  return (
    <section id="faq" data-testid="faq-section" className="bg-[#FAFBFD] py-20 sm:py-28">
      <div className="mx-auto max-w-3xl px-4 sm:px-6 lg:px-8">
        <Reveal>
          <p className="text-xs font-semibold uppercase tracking-[0.25em] text-indigo-600">Preguntas frecuentes</p>
          <h2
            className="mt-3 text-3xl font-medium tracking-tight text-slate-900 sm:text-4xl"
            style={{ fontFamily: "'Outfit', sans-serif" }}
          >
            Lo que todos preguntan antes de empezar
          </h2>
        </Reveal>

        <div data-testid="faq-accordion-container" className="mt-10 divide-y divide-slate-200 border-y border-slate-200">
          {faqs.map((f, i) => (
            <div key={i}>
              <button
                data-testid={`faq-question-${i}`}
                onClick={() => setOpen(open === i ? -1 : i)}
                aria-expanded={open === i}
                className="flex w-full items-center justify-between gap-4 py-5 text-left"
              >
                <span className={`text-base font-medium transition-colors duration-300 ${open === i ? "text-indigo-700" : "text-slate-800"}`}>
                  {f.q}
                </span>
                <motion.span animate={{ rotate: open === i ? 45 : 0 }} transition={{ duration: 0.3 }}>
                  <Plus className={`h-5 w-5 shrink-0 ${open === i ? "text-indigo-600" : "text-slate-400"}`} />
                </motion.span>
              </button>
              <AnimatePresence initial={false}>
                {open === i && (
                  <motion.div
                    data-testid={`faq-answer-${i}`}
                    initial={{ height: 0, opacity: 0 }}
                    animate={{ height: "auto", opacity: 1 }}
                    exit={{ height: 0, opacity: 0 }}
                    transition={{ duration: 0.35, ease: [0.22, 1, 0.36, 1] }}
                    className="overflow-hidden"
                  >
                    <p className="pb-6 pr-10 text-sm leading-relaxed text-slate-600">{f.a}</p>
                  </motion.div>
                )}
              </AnimatePresence>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
